<template>
    <section class="feedback"></section>
</template>

<script>
export default {
  name: 'Feedback'
}
</script>

<style lang="scss" scoped>
    @import '../style/main';

    .feedback {

    }
</style>
